document.addEventListener("DOMContentLoaded", function () {
  const navTriggerOpen = document.querySelector('.js-nav-trigger-open');
  const navTriggerClose = document.querySelector('.js-nav-trigger-close');
  const navMenu = document.querySelector('.js-nav-mobile');
  const navMenuActiveClass = 'is-visible';

  if (navTriggerOpen && navMenu) {
    navTriggerOpen.addEventListener('click', function () {
      navMenu.classList.add(navMenuActiveClass);
    });
  }
  if (navTriggerClose && navMenu) {
    navTriggerClose.addEventListener('click', function () {
      navMenu.classList.remove(navMenuActiveClass);
    });
  }
});